// extracted by mini-css-extract-plugin
export default {"payme-share-modal":"payme-share-modal_payme-share-modal__lM2GK"};